export default "__VITE_ASSET__2G7_s5wq__"